import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { Portal } from "react-portal"
import { withRadium, DetectThresholds, keyframes } from "higher-order-components"
import { noop, bindAll } from "utils"
import { CloseButton } from "components"
import bowser from "bowser"

export class ToastPopup extends PureComponent {
  constructor() {
    super()
    this.state = {
      open: false
    }
    bindAll(["close", "open", "handleCloseClick"], this)
  }
  componentDidMount() {
    setTimeout(() => {
      this.open()
    }, 100)
  }
  componentWillUnmount() {
    this.close()
  }
  componentWillUpdate(nextProps, nextState) {
    if (!nextState.open) {
      if (ToastPopup.activeInstanse === this) {
        ToastPopup.activeInstanse = null
      }
    } else {
      if (ToastPopup.activeInstanse && ToastPopup.activeInstanse !== this) {
        ToastPopup.activeInstanse.close()
      }
      ToastPopup.activeInstanse = this
    }
  }
  componentDidUpdate() {
    // ** DIRTY HACK ** DIRTY HACK **
    // Avoid opacity flicker on iOS by hiding / showing root node
    // if (this.rootNode) {
    //   setTimeout(() => {
    //     if (this.rootNode) this.rootNode.style.opacity = this.state.open ? 1 : 0
    //   }, 80)
    // }
  }
  handleCloseClick() {
    this.close()
  }
  open() {
    this.setState({ open: true })
  }
  close() {
    this.props.onClose && this.props.onClose()
    this.props.onCloseClick && this.props.onCloseClick()
    if (ToastPopup.activeInstanse === this) {
      ToastPopup.activeInstanse = null
    }
    this.setState({ open: false })
  }
  render() {
    const { thresholds, yOffset, children } = this.props
    const { open } = this.state
    const styles = ToastPopupStyles(thresholds)
    const { compact } = thresholds

    return (
      <Portal>
        <div
          ref={(c) => {
            this.rootNode = c
          }}
          style={{
            ...styles.base(Number(yOffset) || 0),
            display: this.props.show ? "block" : "none"
          }}
          data-test="toast-popup">
          <div style={styles.container}>
            <div style={styles.content}>{children}</div>
            <div
              data-test="toast-close"
              style={styles.closeContainer}
              onClick={this.handleCloseClick}
              key={"close"}>
              <CloseButton
                styleName={CloseButton.STYLE_NAMES.LIGHT}
                style={styles.closeButton}
                onClick={this.handleCloseClick} />
              {compact ? <div>Close</div> : ""}
            </div>
          </div>
        </div>
      </Portal >
    )
  }
}

export default withRadium(DetectThresholds())(ToastPopup)

ToastPopup.propTypes = {
  onClose: PropTypes.func,
  onCloseClick: PropTypes.func.isRequired,
  children: PropTypes.node,
  yOffset: PropTypes.number,
  thresholds: PropTypes.shape({
    compact: PropTypes.bool,
    wide: PropTypes.bool
  })
}

ToastPopup.defaultProps = {
  onClose: noop,
  children: [],
  yOffset: 0,
  thresholds: {
    compact: true,
    wide: false
  }
}

const appearKeyframes = keyframes({
  from: {
    transform: "translateY(10vh)",
    opacity: 0
  },
  to: {
    transform: "translateY(0)",
    opacity: 1
  }
})

const ToastPopupStyles = ({ compact, wide }) => ({
  base: yOffset => ({
    position: "fixed",
    width: "90vw",
    maxWidth: "1200px",
    left: "50%",
    bottom: 0,
    zIndex: "50",
    transform: `translate(-50%, ${-3 + yOffset}em)`
  }),
  container: {
    background: "#2d2d2d",
    alignItems: "center",
    justifyContent: "center",
    flexAlign: "middle",
    textAlign: "left",
    color: "white",
    textTransform: "none",
    padding: compact ? "1.6em" : "1.2em 2em",
    display: "flex",
    opacity: 0,
    flexDirection: "row",
    flexWrap: compact ? "wrap" : "nowrap",
    animation: bowser.ios && bowser.version < 10 ? undefined : "x .666s 0.001s forwards", // remove ios check when ios 9 support dropped
    animationName: appearKeyframes
  },
  content: {
    display: "flex",
    textAlign: "center",
    flexGrow: 1,
    alignItems: "center",
    flexDirection: "column",
    ...(compact
      ? {}
      : {
        paddingRight: "2em",
        textAlign: "left",
        flexDirection: "row"
      })
  },
  closeContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textTransform: "lowercase",
    cursor: "pointer"
  },
  closeButton: {
    display: compact ? "inline-block" : "block",
    position: "static",
    top: "auto",
    left: "auto",
    right: "auto",
    margin: compact ? "0 0.4em 0 0" : "auto",
    width: compact ? "0.8em" : "2em",
    height: compact ? "0.8em" : "2em"
  }
})



// WEBPACK FOOTER //
// ./src/containers/toast-popup/index.jsx